import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Redirect } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import { formatDate } from '../../utils/utilityfunction'
import { aggiungiEvento } from '../../actions/agenda';


const AggiungiEvento = ({ auth: { user, loading }, alert, agenda: { eventi }, aggiungiEvento }) => {

  useEffect(() => {
    const size = alert.length;
    if (size > 0) {
      if (alert[size - 1].alertType === "success") {
        setEventoData({
          titolo: "",
          descrizione: "",
          data: formatDate(new Date()),
          orario: "",
          link: ""
        })
      }
    }
  }, [alert]);

  const [eventoData, setEventoData] = useState({
    titolo: "",
    descrizione: "",
    data: formatDate(new Date()),
    orario: "",
    link: ""
  });

  const onChange = e => {
    setEventoData({ ...eventoData, [e.target.name]: e.target.value });
  };

  const onSubmitAggiungiEvento = (e) => {
    e.preventDefault();
    aggiungiEvento({ titolo, descrizione, data, orario, link });
  };

  const { titolo, descrizione, data, orario, link } = eventoData;


  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/login" />;
  }

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                    <div className="_1rem">
                      <div>
                        <h1 className="heading-3">Aggiungi evento</h1>
                      </div>
                      <div className="call-add-evento">
                        <div className="call-item">
                          <div className="call-item-wrap">
                            <div className="fd-form _100 w-form">
                              <form id="email-form" name="email-form" data-name="Email Form" className="form" aria-label="Email Form" onSubmit={(e) => { onSubmitAggiungiEvento(e) }}>
                                <div className="_100">
                                  <label htmlFor="titolo">Titolo evento <span class="required">*</span></label>
                                  <input className="input w-input" maxLength="256" name="titolo" data-name="titolo"
                                    placeholder="Inserisci il titolo dell'evento" type="text" id="titolo" value={titolo} required={true} onChange={e => onChange(e)} />
                                </div>
                                <div className="_100">
                                  <label htmlFor="descrizione">Descrizione</label>
                                  <textarea placeholder="Inserisci descrizione dell'evento" maxLength="5000" id="descrizione" name="descrizione" data-name="descrizione" className="input w-input" value={descrizione} onChange={e => onChange(e)}></textarea>
                                </div>
                                <div className="_100">
                                  <label htmlFor="data">Data evento <span class="required">*</span></label>
                                  <input type="date" className="input-field w-input" name="data" data-name="data" id="data" value={data} onChange={e => onChange(e)} />
                                </div>
                                <div className="_100">
                                  <label htmlFor="orario">Orario evento <span class="required">*</span></label>
                                  <input type="time" className="input-field w-input" name="orario" data-name="orario" id="orario" value={orario} onChange={e => onChange(e)} />
                                </div>
                                <input type="submit" data-wait="Un attimo..." className="submit-button w-button" value="Aggiungi" />
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

AggiungiEvento.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  agenda: PropTypes.func.isRequired,
  aggiungiEvento: PropTypes.func.isRequired

}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  agenda: state.agenda
});

export default connect(mapStateToProps, { aggiungiEvento })(AggiungiEvento);